export const API_BASE_USERS = 'https://5uqm251uv5.execute-api.ap-northeast-3.amazonaws.com/prod/api/admin/users';
export const API_BASE_COMPANIES = 'https://5uqm251uv5.execute-api.ap-northeast-3.amazonaws.com/prod/api/admin/companies';
export const API_BASE_DELIVERABLE = 'https://5uqm251uv5.execute-api.ap-northeast-3.amazonaws.com/prod/api/admin/deliverable';


export const ROLE = {
  USER: 1,
  MANAGER: 5,
  ADMIN: 9,
};
